import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";


export const fetchTransferHistory = createAsyncThunk(
  "procurement/fetchTransferHistory",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    const response: any = await Axios.get(`/item`, {
      // const response: any = await Axios.get(`/field-engineer/fetchMyteam`, {
      params: {
        page,
        page_size: pageSize,
        search: search || undefined,
        filters: filters ? JSON.stringify(filters) : undefined,
      },
    });
    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);





